import SingleDatePicker, {
  SingleDatePickerProps,
} from '@justgiving/date-picker/es/SingleDatePicker';
import '@justgiving/date-picker/es/SingleDatePicker.scss';
import cn from 'classnames';
import React, { FunctionComponent } from 'react';
import FormGroup, { FormGroupProps } from '../FormGroup/FormGroup';
import styles from './FormDatePicker.scss';

export type FormDatePickerProps = SingleDatePickerProps & FormGroupProps;

const FormDatePicker: FunctionComponent<FormDatePickerProps> = ({
  className,
  ...props
}) => {
  return (
    <FormGroup
      className={cn(styles.formDatePicker, className ?? '')}
      {...props}
    >
      <SingleDatePicker {...props} />
    </FormGroup>
  );
};

export default FormDatePicker;
